import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const storeOfficesAdapter = createEntityAdapter({})

const initialState = storeOfficesAdapter.getInitialState()

export const storeOfficeApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getStoreOffices: builder.query({
            query: () => ({
                url: '/storeoffices',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedstoreoffices = responseData.map(storeoffice => {
                    // console.log(storeoffice)
                    storeoffice.id = storeoffice._id
                    // console.log(storeoffice)
                    return storeoffice
                });
                return storeOfficesAdapter.setAll(initialState, loadedstoreoffices)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'STOREOFFICE', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'STOREOFFICE', id }))
                    ]
                } else return [{ type: 'STOREOFFICE', id: 'LIST' }]
            }
        }),
        addNewStoreOffice: builder.mutation({
            query: initialUserData => ({
                url: '/storeoffices',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'STOREOFFICE', id: "LIST" }
            ]
        }),
        updateStoreOffice: builder.mutation({
            query: initialUserData => ({
                url: '/storeoffices',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'STOREOFFICE', id: arg.id }
            ]
        }),        
        deleteStoreOffice: builder.mutation({
            query: ({ id }) => ({
                url: `/storeoffices`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'STOREOFFICE', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetStoreOfficesQuery,
    useAddNewStoreOfficeMutation,
    useUpdateStoreOfficeMutation,
    useDeleteStoreOfficeMutation, 
} = storeOfficeApiSlice

// returns the query result object
export const selectstoreofficesResult = storeOfficeApiSlice.endpoints.getStoreOffices.select()

// creates memoized selector
const selectstoreofficesData = createSelector(
    selectstoreofficesResult,
    storeofficesResult => storeofficesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllstoreoffices,
    selectById: selectstoreofficeById,
    selectIds: selectstoreofficeIds
    // Pass in a selector that returns the users slice of state
} = storeOfficesAdapter.getSelectors(state => selectstoreofficesData(state) ?? initialState)